<template>
  <div class="timelock">
    <gov-header />

    <section class="section is-paddingless proposals-and-timelocks">
      <div class="columns is-centered">
        <div class="column is-three-fifths-desktop is-four-fifths-tablet">
          <div
            class="box info-box loading"
            v-if="$store.daoParameters === null ||
                  ($store.daoParameters.timelockItem !== null && $store.timelockItemOutcome === null) ||
                  ($store.wallet !== null && $store.kDAOCheckpointCount === null)"
          >
            <div class="loader-wrapper">
              <div class="loader is-large is-primary"></div>
            </div>
          </div>
          <div v-else>
            <proposal
              v-if="$store.daoParameters.timelockItem !== null"
              :poll-data="$store.timelockItemOutcome.poll"
              :prop-number="$store.daoParameters.timelockItem.id.toNumber()"
              :read-only="true"
            >
              <template v-slot:extra-header>

                <hr>
                <timelock-countdowns
                  :timelock-outcome="$store.timelockItemOutcome"
                  :timelock-item="$store.daoParameters.timelockItem" />

                <div class="buttons is-right">
                  <button
                    @click="cancelTimelock"
                    :disabled="networkLoading || !timelockIsCancellable"
                    class="button is-danger"
                    :class="{'is-loading': networkLoading}"
                  >
                    Cancel Proposal
                  </button>
                  <button
                    @click="executeTimelock"
                    :disabled="networkLoading || !timelockIsExecutable"
                    class="button is-primary"
                    :class="{'is-loading': networkLoading}"
                  >
                    Execute Proposal
                  </button>
                </div>
                <hr>

              </template>

              <template v-slot:extra-footer v-if="$store.wallet !== null">
              </template>
            </proposal>
            <div v-else class="box info-box content">
              <h1>Nothing Here!</h1>
              <p>There is nothing currently in the timelock.</p>
              <router-link :to="{'name': 'Index'}" class="button is-primary">Return Home</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";

import GovHeader from "@/components/GovHeader";
import Proposal from "@/components/Proposal";
import TimelockCountdowns from "@/components/TimelockCountdowns";

export default {
  name: 'Index',
  components: {TimelockCountdowns, Proposal, GovHeader},
  async mounted(){
    setInterval(() => {
      this.tick = new Date()
    }, 1000)
  },
  data(){
    return {
      tick: new Date(),
      networkLoading: false,
      proposalDetails: null,
    }
  },
  methods:{
    async cancelTimelock(){
      this.networkLoading = true
      let sendResult
      try{
        const daoContract = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO)
        sendResult = await daoContract.methods.cancelTimelock(null).send()
        this.$eventBus.$emit('tx-submitted', sendResult)
        await sendResult.confirmation(1)

        this.$store.daoParameters = null
        this.$eventBus.$emit('update-dao-info')

        this.$router.push({name: 'Index'})
      } catch(e) {
        console.log("Error cancelling!")
        console.error(e)
      } finally {
        this.$eventBus.$emit('tx-finished')
        this.networkLoading = false
      }
    },
    async executeTimelock(){
      this.networkLoading = true
      const lockupVaultAddress = this.$store.contracts.VOTING_VAULTS[this.$store.walletAddress]

      let sendResult
      try{
        const contract = lockupVaultAddress === undefined ?
          await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO) :
          await this.$store.tezosToolkit.wallet.at(lockupVaultAddress)

        sendResult = await contract.methods.executeTimelock(null).send()
        this.$eventBus.$emit('tx-submitted', sendResult)
        await sendResult.confirmation(1)

        this.$store.daoParameters = null
        this.$eventBus.$emit('update-dao-info')
        this.$router.push({name: 'Index'})
      } catch(e) {
        console.log("Error cancelling!")
        console.error(e)
      } finally {
        this.$eventBus.$emit('tx-finished', sendResult)
        this.networkLoading = false
      }
    }
  },
  computed: {
    blocksUntilTimelockExecutable(){
      return this.$store.daoParameters.timelockItem.endBlock.minus(this.$store.currentBlockHeight)
    },
    blocksUntilTimelockCancellable(){
      return this.$store.daoParameters.timelockItem.cancelBlock.minus(this.$store.currentBlockHeight)
    },
    timelockIsExecutable(){
      const lockupVaultAddress = this.$store.contracts.VOTING_VAULTS[this.$store.walletAddress]

      return this.blocksUntilTimelockExecutable.isLessThanOrEqualTo(0) &&
        (this.$store.daoParameters.timelockItem.author === this.$store.walletAddress ||
          this.$store.daoParameters.timelockItem.author === lockupVaultAddress)
    },
    timelockExecutableIn(){
      const durationSeconds = this.blocksUntilTimelockExecutable * this.$store.blockTime
      if (durationSeconds > 0){
        return moment.duration(durationSeconds).humanize(true)
      } else {
        return "Now"
      }
    },
    timelockIsCancellable(){
      return this.blocksUntilTimelockCancellable.isLessThanOrEqualTo(0)
    },
    timelockCancellableIn(){
      const durationSeconds = this.blocksUntilTimelockCancellable * this.$store.blockTime
      if (durationSeconds > 0){
        return moment.duration(durationSeconds).humanize(true)
      } else {
        return "Now"
      }
    },
  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.timelock{
  @include until($tablet){
    padding: 1rem;
    background: $primary;
  }
  .voting-info{
    .vote-container{
      &:not(:last-child){
        margin-bottom: 1rem;
      }
      .vote-topper{
        display: flex;
        justify-content: space-between;
      }
      progress{
        margin-top: .5rem;
      }
    }
    h3{
      margin-top: 1rem;
    }
    .progress-footer{
      padding: 0.5rem 0.25rem;
      display: flex;
      justify-content: space-between;
    }
  }
  .proposals-and-timelocks{
    margin-bottom: 1rem;
  }
  .proposal-title{
    margin-top: 0 !important;
  }
  .proposal-description{
    overflow: auto;
    border: 2px solid #f5f5f5;
    border-radius: 5px;
    padding: 1rem;
  }
  .contract-info{
    position: fixed;
    z-index: 99999;
    bottom: 0;
    left: 1rem;
    background: $primary;
    border-left: 2px solid white;
    border-right: 2px solid white;
    border-top: 2px solid white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 1rem;
  }
  .top-piece{
    @include until($tablet){
      flex-direction: column-reverse;
      display: flex;
    }
  }
  .top-section{
    background: $primary;
    padding-bottom: 8rem;
    .hero-body{
      .title{
        font-size: 3.25rem;
      }
      .subtitle{
        font-size: 1.875rem;
      }
    }
  }
  .info-box{
    margin-top: -6rem;
    margin-bottom: 6rem;
    &.loading{
      padding: 3rem 0;
    }
  }
}

</style>
